<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="w-full max-w-lg mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody>
          <SoftOneApiForm :action="createSoftOneApiService" @cancel="$refs.modal.close()" />
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import BaseCard from 'Components/BaseCard.vue';
import { accountSoftOneApiServicesClient } from '@/api/clients';
import SoftOneApiForm from './SoftOneApiForm.vue';

export default {
  components: {
    SoftOneApiForm,
    BaseCard,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    async createSoftOneApiService(formData) {
      try {
        await this.$store.dispatch('ui/accountThirdPartyServices/storeFromService', {
          accountId: this.accountId,
          formData,
          service: accountSoftOneApiServicesClient.store,
        });

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
